@if (visible()) {
  <div class="esn-env-badge">
    <span class="esn-env-badge__chip" [attr.data-tone]="tone(frontend())" [attr.title]="title('UI', uiVersion()) || null">
      <span class="esn-env-badge__key">UI</span>{{ frontend() }}
      @if (sha(uiVersion()); as s) { <span class="esn-env-badge__build">{{ s }}</span> }
      @if (built(uiVersion()); as b) { <span class="esn-env-badge__build esn-env-badge__build--time">{{ b }}</span> }
    </span>
    <span class="esn-env-badge__chip" [attr.data-tone]="tone(apiSource())" [attr.title]="title('API', apiVersion()) || null">
      <span class="esn-env-badge__key">API</span>{{ apiSource() }}
      @if (sha(apiVersion()); as s) { <span class="esn-env-badge__build">{{ s }}</span> }
      @if (built(apiVersion()); as b) { <span class="esn-env-badge__build esn-env-badge__build--time">{{ b }}</span> }
    </span>
  </div>
}
